import { Checkbox, Grid, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import DialogBoxComp from "../../../components/common/DialogBox/DialogBoxComp";
import ScreenCard from "../../../components/common/ScreenCard/ScreenCard";
import TableComp from "../../../components/common/TableComp/TableComp";
import InputWithBtnLayoutComp from "../../../components/InputWithBtnLayout/InputWithBtnLayoutComp";
import InputComp from "../../../components/common/InputComp/Input";
import TabComp from "../../../components/TabsComp/TabComp";
import Btn from "../../../components/common/ButtonComp/Btn";
import { asyncStatus } from "../../../utils/asyncStatus";
import { primaryColor } from "../../../utils/themeColors";
import {
  addOMBergenBillingAsync,
  deleteOMBergenBillingAsync,
  editOMBergenBillingAsync,
  getOMBergenBillingAsync,
} from "../../../store/services/orderManagementService";
const BergenBilling = () => {
  const dispatch = useDispatch();
  const {
    getOMBergenBillingStatus,
    getOMBergenBillingError,
    getOMBergenBillingData,
    addOMBergenBillingStatus,
    addOMBergenBillingData,
    addOMBergenBillingError,

    editOMBergenBillingStatus,
    editOMBergenBillingError,
    editOMBergenBillingData,

    deleteOMBergenBillingData,
    deleteOMBergenBillingStatus,
    deleteOMBergenBillingError,
  } = useSelector((state) => state.om);

  useEffect(() => {
    dispatch(getOMBergenBillingAsync());
  }, []);

  // console.log("getProductStyleData", getProductStyleData);
  const formattedData = getOMBergenBillingData?.length
    ? getOMBergenBillingData.map((style, index) => ({
        id: index + 1, // Assuming the index is a unique identifier for each row
        ...style,
      }))
    : [];
  const [selectedBergenBilling, setSelectedBergenBilling] = useState();
  const [addBergenBillingMode, setAddBergenBillingMode] = useState(false);
  const [addBergenBillingData, setAddBergenBillingData] = useState();
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [editData, setEditData] = useState();
  const [editMode, setEditMode] = useState(false);
  // console.log("selectedBergenBilling", selectedBergenBilling);
  // console.log("editData", editData);
  useEffect(() => {
    if (addOMBergenBillingStatus === asyncStatus.SUCCEEDED) {
      setAddBergenBillingMode(false);
      setSaveDisabled(true);
      setAddBergenBillingData();
    }
  }, [, addOMBergenBillingStatus]);

  const [open, setOpen] = useState(false);
  const agree = () => {
    dispatch(deleteOMBergenBillingAsync(selectedBergenBilling?.bergan_billing_id));
  };
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (deleteOMBergenBillingStatus === asyncStatus.SUCCEEDED || deleteOMBergenBillingStatus === asyncStatus.ERROR ) {
      setOpen(false);
      setSelectedBergenBilling();
    }
  }, [, deleteOMBergenBillingStatus]);
  useEffect(() => {
    if (editOMBergenBillingStatus === asyncStatus.SUCCEEDED) {
      setSelectedBergenBilling();
      setEditMode(false);
      setEditData()
    }
  }, [, editOMBergenBillingStatus]);

  //   const [tableHeight, setTableHeight] = useState("");
  //   let elem = document.getElementById("containerHeight");
  //   useEffect(() => {
  //     console.log("elem?.offsetHeight",elem?.clientHeight);
  //     setTableHeight(elem?.offsetHeight);
  //   }, [ elem?.offsetHeight]);
  // console.log(containerHeight)
  return (
    <Stack padding={2}>
      <DialogBoxComp
        open={open}
        handleClose={handleClose}
        agree={agree}
        innerContent={"Are you sure you want to delete this bergen billing option?"}
        heading={"Delete request"}
      />
      <ScreenCard
        title="Bergen Billing Option"
        customHeader={
          <Stack
            sx={{
              padding: 0.5,
              px: 4,
              backgroundColor: primaryColor,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "white", fontWeight: "bold" }}>
              Bergen Billing Option
            </Typography>
            <Stack flexDirection={"row"} gap={1}>
              <IconButton
                onClick={() => {
                  setEditMode(false);
                  setAddBergenBillingMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!addBergenBillingMode ? (
                  <AddIcon sx={{ color: "white" }} />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addBergenBillingMode}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  setAddBergenBillingMode(false);
                  setEditMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!editMode ? (
                  <EditIcon />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addBergenBillingMode || !selectedBergenBilling}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => setOpen(true)}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                disabled={
                  addOMBergenBillingStatus === asyncStatus.LOADING ||
                  editOMBergenBillingStatus === asyncStatus.LOADING ||
                  saveDisabled
                }
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  if (addBergenBillingData) {
                    dispatch(addOMBergenBillingAsync(addBergenBillingData));
                  } else if (editMode) {
                    let a;
                    a = { ...selectedBergenBilling, ...editData };
                    delete a.id;
                    dispatch(editOMBergenBillingAsync(a));
                  }
                }}
              >
                <SaveIcon />
              </IconButton>
            </Stack>
          </Stack>
        }
      >
        <Grid container>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
            <Stack height={500} width={"100%"}>
              <TableComp
                columns={[
                  { field: "bergan_billing_id", headerName: "ID", flex: true },
                  { field: "bergan_billing_name", headerName: "Bergen Billing Option", flex: true },
                ]}
                onRowClick={(e) => {
                  setSelectedBergenBilling(e?.row);
                }}
                rows={formattedData}
                loading={
                  getOMBergenBillingStatus === asyncStatus.IDLE ||
                  getOMBergenBillingStatus === asyncStatus.LOADING
                }
              />
            </Stack>
          </Grid>
          <Grid item xl={9} lg={9} md={9} sm={12} xs={12} padding={2}>
            {addBergenBillingMode ? (
              <InputWithBtnLayoutComp
              error={addOMBergenBillingError}
                inputArray={[
                  {
                    label: "Bergen Billing Option:",
                    comp: (
                      <InputComp
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        onChange={(e) =>
                          setAddBergenBillingData({
                            ...addBergenBillingData,
                            bergan_billing_name: e.target.value,
                          })
                        }
                      />
                    ),
                  },
                  {
                    label: "Active:",
                    comp: (
                      <Checkbox
                        defaultChecked
                        defaultValue={true}
                        onChange={(e) =>
                          setAddBergenBillingData({
                            ...addBergenBillingData,
                            is_active: e.target.checked,
                          })
                        }
                      />
                    ),
                  },
                ]}
                secondaryComp={<></>}
              />
            ) : selectedBergenBilling ? (
              <InputWithBtnLayoutComp
              error={editOMBergenBillingError}
                inputArray={[
                  {
                    label: "ID:",
                    comp: (
                      <Typography sx={{ fontSize: 14 }}>
                        {selectedBergenBilling?.bergan_billing_id}
                      </Typography>
                    ),
                  },
                  {
                    label: "BergenBilling:",
                    comp: (
                      <InputComp
                        key={selectedBergenBilling?.bergan_billing_id} // Add key prop to force remount
                        disabled={!editMode}
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            bergan_billing_name: e.target.value,
                          })
                        }
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        defaultValue={selectedBergenBilling?.bergan_billing_name}
                      />
                    ),
                  },
                  {
                    label: "Active:",

                    comp: (
                      <Checkbox
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            is_active: e.target.checked,
                          })
                        }
                        value={selectedBergenBilling?.is_active|| editData?.is_active}
                        disabled={!editMode}
                        // defaultValue={selectedBergenBilling?.is_active || editData?.is_active}
                        defaultChecked={selectedBergenBilling?.is_active || editData?.is_active}
                        // checked={selectedBergenBilling?.is_active}
                      />
                    ),
                  },
                ]}
                secondaryComp={
                  <Btn
                    style={{ fontSize: 10, fontWeight: "bold" }}
                    disabled={editMode}
                  >
                    Assign Companies
                  </Btn>
                }
              />
            ) : (<Stack>
              <Typography>Select any bergen billing option</Typography>
              <Typography color={"red"} fontSize={12}>{getOMBergenBillingError}</Typography>
            </Stack>
            )}
            <Stack my={2}>
              <TabComp
                tabs={[
                  //   {
                  //     name: "Companies",
                  //     content: (
                  //       <Stack height={400} width={"100%"}>
                  //         <TableComp
                  //           columns={[
                  //             {
                  //               field: "companyId",
                  //               headerName: "Company ID",
                  //               flex: true,
                  //             },
                  //             {
                  //               field: "companyName",
                  //               headerName: "Company Name",
                  //               flex: true,
                  //             },
                  //             {
                  //               field: "action",
                  //               headerName: "Action",
                  //               flex: true,
                  //             },
                  //           ]}
                  //           //   onRowClick={(e) => {
                  //           //     setSelectedBergenBilling(e?.row);
                  //           //   }}
                  //           rows={[]}
                  //           //   loading={
                  //           //     getProductStyleStatus === asyncStatus.IDLE ||
                  //           //     getProductStyleStatus === asyncStatus.LOADING
                  //           //   }
                  //         />
                  //       </Stack>
                  //     ),
                  //   },
                  {
                    name: "Log Info",
                    content: (
                      <Stack height={400} width={"100%"}>
                        <TableComp
                          columns={[
                            {
                              field: "logId",
                              headerName: "Log ID",
                              flex: true,
                            },
                            {
                              field: "recordId",
                              headerName: "Record_id",
                              flex: true,
                            },
                            {
                              field: "columnName",
                              headerName: "Column Name",
                              flex: true,
                            },
                            {
                              field: "columnValue",
                              headerName: "Column Value",
                              flex: true,
                            },
                            {
                              field: "actionName",
                              headerName: "Action Name",
                              flex: true,
                            },
                            {
                              field: "actionDate",
                              headerName: "Action Date",
                              flex: true,
                            },
                            {
                              field: "userId",
                              headerName: " User ID",
                              flex: true,
                            },
                          ]}
                          //   onRowClick={(e) => {
                          //     setSelectedBergenBilling(e?.row);
                          //   }}
                          rows={[]}
                          //   loading={
                          //     getProductStyleStatus === asyncStatus.IDLE ||
                          //     getProductStyleStatus === asyncStatus.LOADING
                          //   }
                        />
                      </Stack>
                    ),
                  },
                ]}
              />
            </Stack>
          </Grid>
        </Grid>

        {/* <div style={{ height: 400, width: '100%' }}>
      <DataGrid
      sty
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
        // checkboxSelection
      />
    </div> */}
      </ScreenCard>
    </Stack>
  );
};

export default BergenBilling;
